import { render, staticRenderFns } from "./translate.vue?vue&type=template&id=e05414ee"
import script from "./translate.ts?vue&type=script&lang=js&external"
export * from "./translate.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports